var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('notifications',{attrs:{"group":"app","position":"bottom right","duration":10000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }